import styled from 'styled-components';

export const FocusBoundary = styled.main`
  position: absolute;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  top: 4px;
  left: 4px;
  z-index: 10;
  pointer-events: none;
  background: transparent !important;
`;
